import { render } from "./PwaUpdateBanner.vue?vue&type=template&id=c54607d6"
import script from "./PwaUpdateBanner.vue?vue&type=script&lang=js"
export * from "./PwaUpdateBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__